import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import { reactSelectStyles } from '../helpers/utils.js';

class ServiceFilter extends Component {
    state = {
        serviceTypeLists:[{value: '', label: 'All'}],
        serviceTypeValue: {value: '', label: 'All'},
        isServiceLoading: true
    };
    componentDidMount(){
        this.getServiceType();
    }
    restServiceFilter() {
        this.setState({
            serviceTypeValue: {value: '', label: 'All'},
        })
    }
    getServiceType(){
        axios.get(config.get('API_URL')+'/filters/get-service-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((service, index) => {
                    this.state.serviceTypeLists.push({value: service.service_code, label: service.service_display_name})
                });
            }
            this.setState({
                loading:false,
                isServiceLoading: false
            })
        });

    }

    changeServiceType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.props.onSelectService(optionSelected);
        this.setState({
            serviceTypeValue:optionSelected,
        });
    }
    render() {

        return (
            <Select name="service_type"
                value={this.state.serviceTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeServiceType.bind(this)}
                options={this.state.serviceTypeLists}
                isLoading={this.state.isServiceLoading}
                placeholder="[Service Type]"
            />
        );

    }
}
export default ServiceFilter;